import React from 'react'
import PropTypes from 'prop-types'
import { FaIcon } from 'SharedComponents'
import { GGToggle } from '../../../shared/new_components/GGToggle'
import { GGMenu } from '../../../shared/new_components/GGMenu'

// Mobile (<=992px) card for the hub events table. Reuses the legacy
// sim_golf card CSS classes but is hub-owned: shared/components/sim_golf/*
// is a frozen contract and must not grow feature-specific props.
const LeagueCardHub = ({
  id,
  name,
  startDate,
  confirmedGolfers,
  menuOptions,
  onMenuSelect,
  published,
  isRegistrationPresent,
  isRegistrationOpen,
  setRegistrationOpen,
  setupRegistrationLink,
  leagueURL,
}) => {
  const registrationLabel = (statusKey) =>
    `${window.I18n.t('gg_golf_hub.dashboard.table.registration')}: ${window.I18n.t(`gg_golf_hub.dashboard.${statusKey}`)}`

  return (
    <span className='glg-table-card' id={ `row_${id}` }>
      <span className='row first_row'>
        <span className='name_field'><a href={ leagueURL }>{ name }</a></span>
        <span className='action_field'>
          <GGMenu options={ menuOptions } onSelect={ onMenuSelect } position='left' />
        </span>
      </span>
      <span className='row second_row'>
        <span className='second_row_details'>
          <span className='date_field'>
            { startDate && <FaIcon icon='calendar-o' /> }
            { startDate }
          </span>
          <span className='golfers_field'>
            { confirmedGolfers } { window.I18n.t('gg_golf_hub.dashboard.stats.golfers', { count: confirmedGolfers }) }
          </span>
        </span>
        <span className='sim_table_card_helper'>
          {isRegistrationPresent ?
            <span className='registration_cell_container'>
              <GGToggle
                className='font-size-14'
                checked={ published && isRegistrationOpen }
                disabled={ !published }
                onChange={ setRegistrationOpen }
                labelOn={ registrationLabel('open') }
                labelOff={ registrationLabel('closed') }/>
            </span> :
            <a className='registration_setup_link' href={ setupRegistrationLink }>
              { window.I18n.t('gg_golf_hub.dashboard.set_up') }
            </a>}
        </span>
      </span>
    </span>
  )
}

LeagueCardHub.propTypes = {
  id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  name: PropTypes.string,
  startDate: PropTypes.string,
  confirmedGolfers: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  menuOptions: PropTypes.array,
  onMenuSelect: PropTypes.func,
  published: PropTypes.bool,
  isRegistrationPresent: PropTypes.bool,
  isRegistrationOpen: PropTypes.bool,
  setRegistrationOpen: PropTypes.func,
  setupRegistrationLink: PropTypes.string,
  leagueURL: PropTypes.string,
}

export default LeagueCardHub
